import { render, staticRenderFns } from "./only_goods_mng.vue?vue&type=template&id=4c1e1d18"
import script from "./only_goods_mng.vue?vue&type=script&lang=js"
export * from "./only_goods_mng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1e1d18')) {
      api.createRecord('4c1e1d18', component.options)
    } else {
      api.reload('4c1e1d18', component.options)
    }
    module.hot.accept("./only_goods_mng.vue?vue&type=template&id=4c1e1d18", function () {
      api.rerender('4c1e1d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/source/only_goods_mng.vue"
export default component.exports